import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

export type AddCategoryDTO = {
  name: string;
  description: string;
  img_url: string;
};

type CategoryResponse = AddCategoryDTO & ApiError;

export const AddNewCategory = (
  data: AddCategoryDTO
): Promise<CategoryResponse> => {
  return axios
    .post("/category/create", data)
    .then((response) => response.data as CategoryResponse);
};
